import React from 'react';

import brazilFlag from 'assets/flags/brazil-flag.png';
import UKFlag from 'assets/flags/UK-flag.png';
import spainFlag from 'assets/flags/spain-flag.png';

export default [
  {
    id: 1,
    language: 'pt-BR',
    label: 'Português',
    icon: <img src={brazilFlag} alt="Brazil" />,
  },
  {
    id: 2,
    language: 'en-US',
    label: 'English',
    icon: <img src={UKFlag} alt="UK" />,
  },
  {
    id: 3,
    language: 'es-ES',
    label: 'Español',
    icon: <img src={spainFlag} alt="Spain" />,
  },
];
